import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Avatar } from "@material-ui/core";
import Badge from '@material-ui/core/Badge';
import SettingsIcon from '@material-ui/icons/Settings';
import { withStyles } from "@material-ui/core/styles";
import Radio from "@material-ui/core/Radio";
import IconButton from '@material-ui/core/IconButton';

import { selectChannelId, setChannelInfo, } from "../../../../../store/reducers/appSlice";

import Banner from "../../../Profile/Banner/Banner"
import classes from "./CampaignRoom.module.css";
import RoominvitationService from "../../../../../services/RoominvitationService";


function CampaignRoom({ id, channel }) {

  const dispatch = useDispatch();
  const history = useHistory();
  const activeChannel = useSelector(selectChannelId);

  if (activeChannel === null) {
    (new RoominvitationService()).getActiveInvitationUidForRoomId(id).then(function (inviteUid) {
      dispatch(
        setChannelInfo({
          channelId: id,
          channelName: channel.channelName,
          channelInvitationUid: inviteUid
        })
      );
    })
  }

  function changeCampaign(historyLocation) {
    history.push(historyLocation);
    (new RoominvitationService()).getActiveInvitationUidForRoomId(id).then(function (inviteUid) {
      dispatch(
        setChannelInfo({
          channelId: id,
          channelName: channel.channelName,
          channelInvitationUid: inviteUid
        })
      );
    })
  }

  function handleSelectCampaign() {
    changeCampaign("/campaign")
  }

  const handleChangeCampaign = () => {
    changeCampaign("/")
  };

  const GoldRadio = withStyles({
    root: {
      color: "gold",
      "&$checked": {
        color: "gold",
      },
    },
    checked: {},
  })((props) => <Radio color="default" {...props} />);

  let radio = (
    <Radio
      checked={false}
      onClick={handleChangeCampaign}
      value="c"
      name="radio-button-demo"
      inputProps={{ "aria-label": "C" }}
    />
  );

  if (id === activeChannel) {
    radio = (
      <GoldRadio
        checked={true}
        onClick={handleChangeCampaign}
        value="c"
        name="radio-button-demo"
        inputProps={{ "aria-label": "C" }}
      />
    );
  };

  return (

    <div className={classes.sidebar__channelsHeader}>
      <div className={classes.avatar}>
        <Banner>
          <Badge

            overlap="circle"
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',

            }}
            badgeContent={<IconButton 
              color="primary" 
              fontSize="small" 
              aria-label="add an alarm" 
              alt="Settings"
              className={classes.badge}
              onClick={handleSelectCampaign}>
              <SettingsIcon />
            </IconButton>
            }
          >
            <Avatar
              src={channel.channelImage}
              onClick={handleChangeCampaign}
            />
          </Badge>

        </Banner>

      </div>
      <div onClick={handleChangeCampaign}>
        <h4 className={classes.textHover}>{channel.channelName}</h4>
      </div>

      <div className={classes.sidebar__selectCharacter}>{radio}</div>
    </div>

  );
}

export default CampaignRoom;
